require('../../modules/es7.array.flat-map');
module.exports = require('../../modules/_core').Array.flatMap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/flat-map.js
// module id = 3057
// module chunks = 25